import { type BaseAppState } from "@client/types";
import { createSelector } from "reselect";
import { componentsSelector } from "./state";

const propsGidSelector = (state: BaseAppState, props: { gid: string }) => props.gid;
export const makeComponentSelector = () =>
  createSelector([componentsSelector, propsGidSelector], (items, gid) => items.find((x) => x.contentId === gid));
